document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-legnami-header]').forEach((header) => {
    const button = header.querySelector('[data-legnami-menu-toggle]');
    const menu = header.querySelector('[data-legnami-mobile-menu]');
    if (!button || !menu) return;
    button.addEventListener('click', () => {
      const isOpen = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!isOpen));
      menu.hidden = isOpen;
      header.classList.toggle('is-menu-open', !isOpen);
    });
  });
});
